
      export default {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"60","height":"60","viewBox":"0 0 60 60","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M30 10.002c-1.9-.11-3.493 3.819-4.813 7.073-.773 1.91-1.453 3.587-2.046 4.081-1.512 1.415-4.024 1.402-6.548 1.389-2.65-.014-5.316-.028-6.852 1.611-2.595 2.838 2.24 6.992 5.068 9.42.66.567 1.21 1.04 1.532 1.38 1.108 1.008 1.607 1.28 1.766 1.684.156.4-.018.928-.266 2.416-.16.897-.361 1.814-.564 2.738-.43 1.963-.868 3.959-.936 5.862-.085 5.497 4.837 2.483 8.051.515a34.13 34.13 0 011.549-.915c.306-.159.588-.31.85-.45 1.299-.697 2.14-1.148 3.209-1.073v-35.73z"}})])
          )
        }
      }
    